module.exports = __webpack_public_path__ + "d308073b/img/placeholder.888fcd0b.svg";